// import { ApolloClient, InMemoryCache, ApolloLink } from "@apollo/client";
// import { createUploadLink } from "apollo-upload-client";
// import { api } from "@/lib/api";
// import Cookies from "js-cookie";

// const uploadLink = createUploadLink({
//   uri: api,
//   credentials: 'include',
// });

// const authLink = new ApolloLink((operation, forward) => {
//   const token = Cookies.get("jid"); // نفس اسم الكوكيز عندك
//   if (token) {
//     operation.setContext({
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     });
//   }
//   return forward(operation);
// });

// export const client = new ApolloClient({
//   link: authLink.concat(uploadLink),
//   cache: new InMemoryCache(),
//   connectToDevTools: process.env.NODE_ENV === 'development',
// });

import { ApolloClient, InMemoryCache } from "@apollo/client";
import { createUploadLink } from "apollo-upload-client";
import { api } from "@/lib/api";

const uploadLink = createUploadLink({
  uri: api,
  credentials: "include",
});

export const client = new ApolloClient({
  link: uploadLink,
  cache: new InMemoryCache(),
  // connectToDevTools: process.env.NODE_ENV === "development",
  devtools: {
    enabled: process.env.NODE_ENV === "development",
  },
});
